import {
  applyRegionBaseUrls,
  normalizeRegionCode,
  regionBaseUrls
} from '@/const'

export const namespaced = true

const REGION_STORAGE_KEY = 'preferredRegion'
const DEFAULT_REGION = 'eu'

const storedRegion = normalizeRegionCode(
  localStorage.getItem(REGION_STORAGE_KEY)
)
const initialRegion = regionBaseUrls[storedRegion]
  ? storedRegion
  : DEFAULT_REGION

export const state = {
  currentRegion: initialRegion,
  availableRegions: [
    { code: 'eu', name: 'Europe' },
    { code: 'au', name: 'Australia' }
  ]
}

export const mutations = {
  SET_CURRENT_REGION(state, region) {
    state.currentRegion = region
    localStorage.setItem(REGION_STORAGE_KEY, region)
  }
}

export const actions = {
  switchRegion({ commit, state }, region) {
    const normalizedRegion = normalizeRegionCode(region)
    if (!regionBaseUrls[normalizedRegion]) {
      return Promise.reject(new Error('The selected region is not supported'))
    }
    if (normalizedRegion === state.currentRegion) {
      return Promise.resolve(false)
    }

    applyRegionBaseUrls(normalizedRegion)
    commit('SET_CURRENT_REGION', normalizedRegion)
    return Promise.resolve(true)
  }
}
